"use client";
import * as Select from "@radix-ui/react-select";
import { usePathname, useSearchParams } from 'next/navigation';
import { useRouter } from '@akinon/next/hooks';
import { SortOption } from "@akinon/next/types";
import { Icon } from '@theme/components';

export const CategorySorter = ({sortOptions} : {sortOptions: SortOption[]}) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();

  const handleSelectFilter = ({
    key,
    value
  }: {
    key: string;
    value: string;
  }) => {
    const urlSearchParams = new URLSearchParams(searchParams.toString());

    urlSearchParams.set(key, value);

    router.push(pathname + '?' + urlSearchParams.toString());
  };

  return (
    <Select.Root
      onValueChange={(e) => {
          handleSelectFilter({
            key: 'sorter',
            value: e
          });
        }
      }
    >
      <Select.Trigger
        className="inline-flex h-[30px] items-center justify-center gap-2 text-sm leading-none text-primary-black outline-none"
      >
        <Select.Value placeholder="Sırala" />
        <Select.Icon>
          <Icon
            name="chevron-down"
            size={24}
            aria-hidden
          />
        </Select.Icon>
      </Select.Trigger>
      <Select.Portal>
        <Select.Content position="popper" sideOffset={5} className="overflow-hidden rounded-md bg-white text-sm shadow-[0px_10px_38px_-10px_rgba(22,_23,_24,_0.35),0px_10px_20px_-15px_rgba(22,_23,_24,_0.2)] z-[2]">
          <Select.Viewport className="py-2.5 px-4">
            {sortOptions.map((option) => (
              <Select.Item key={option.value} value={option.value} className="flex items-center h-8">
                <Select.ItemText>{option.label}</Select.ItemText>
              </Select.Item>
            ))}
          </Select.Viewport>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  )
}
